import { type HTMLAttributes } from "react";

type PageProps = HTMLAttributes<HTMLDivElement> & {};

const Section = (props: PageProps) => {
  return <section data-layout="section" {...props} />;
};

export default Section;
